import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { MenuService } from '../../services/menu.service';
import { FormsModule } from '@angular/forms';
import { SelectComponent } from '../../../shared/components/select/select.component';
import { LocalService } from '../../../shared/services/local.service';
import { LocalContextService } from '../../../shared/services/local-context.service';
import { DropDownOption } from '../../../shared/models/drop-down-option';
import { Local } from '../../../shared/models/local';
import { LocalId } from '../../../shared/enums/local.enum';
import { ToastService } from '../../../shared/services/toast.service';
import { ToastState as ts } from '../../../shared/enums/toast-state.enum';

@Component({
  selector: 'app-header',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [TegelModule, SelectComponent, FormsModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  ddlLocais: DropDownOption[] = [];
  selectedLocalId: number | null = null;

  constructor(
    private menu: MenuService,
    private localService: LocalService,
    private localContextService: LocalContextService,
    private toast: ToastService,
  ) {}

  ngOnInit(): void {
    this.localContextService.currentLocalId$.subscribe((localId) => {
      if (localId) {
        this.selectedLocalId = localId;
      } else {
        this.selectedLocalId = LocalId.SLA;
        this.localContextService.setLocal(LocalId.SLA);
      }
    });

    this.localService.getAll().subscribe((result) => {
      if (result.success && result.content) {
        this.formatDropDownOptions(result.content);
      }
    });
  }

  onLocalChange(newId: number) {
    if (newId) {
      this.localContextService.setLocal(Number(newId));
      this.toast.showToast(ts.success, 'Local alterado!');
    }
  }

  private formatDropDownOptions(localList: Local[]) {
    this.ddlLocais = localList.map((local) => ({
      text: local.nome,
      value: local.id,
    }));
  }

  mobileMenuAction(): void {
    this.menu.setSignal(true);
  }
}
